// extracted by mini-css-extract-plugin
export default {"nav":"MobileNav_nav__Y-mfm","icon":"MobileNav_icon__Mdhq8","active":"MobileNav_active__PApaU","navigation":"MobileNav_navigation__IObHh","list":"MobileNav_list__oXhpn"};